$('#SelectedVariantId').on('change', function () {
    variantIdChanged();
});

document.addEventListener('DOMContentLoaded', function () {
    variantIdChanged();
});

function variantIdChanged() {
    const variantEles = document.getElementsByName('id');

    if (!variantEles || variantEles.length === 0) {
        return;
    }

    const variantId = variantEles[0].value;
    const productJsonNode = document.querySelector('#CurrentProductJson');

    if (!productJsonNode) {
        return;
    }

    const product = JSON.parse(productJsonNode.innerHTML);
    const variants = product.variants;
    const currentVariant = variants.find(variant => variant.id == variantId);
    changeVariantDescriptions(variants, variantId);
    hideNonVariantImages(currentVariant, variants);
    changeProgressBar(variantId);
}


function hideNonVariantImages(currentVariant, variants) {
    const relevantImageArray = getImageElements();
    if (!currentVariant || !currentVariant.featured_media) {
        relevantImageArray[0].slice(0, 5).forEach(fn => fn.style.display = 'block');
        return
    }
    const variantImageTag = currentVariant.featured_media.id;
    const variantDataMediaIdEles = [];
    for (const relevantImages of relevantImageArray) {
        let firstVariantImageFound = false;
        for (const dataMediaIdEle of relevantImages) {
            const dataMediaId = dataMediaIdEle.getAttribute('data-media-id');
            if (dataMediaId.includes('template')) {
                continue
            }
            let currentVariantLinksToImage = false;
            if (variantImageTag == dataMediaId) {
                currentVariantLinksToImage = true;
                firstVariantImageFound = true
            }
            let otherVariantLinksToImage = false;
            for (const variant of variants) {
                if (!variant || !variant.featured_media) {
                    continue
                }
                if (variant.id == currentVariant.id) {
                    continue
                }
                if (variant.featured_media.id == dataMediaId) {
                    otherVariantLinksToImage = true
                }
            }
            if (!firstVariantImageFound) {
                continue
            }
            if (firstVariantImageFound && (currentVariantLinksToImage || !otherVariantLinksToImage)) {
                variantDataMediaIdEles.push(dataMediaIdEle)
            } else if (firstVariantImageFound && otherVariantLinksToImage) {
                break
            }
        }
    }
    for (const relevantImages of relevantImageArray) {
        for (const ele of relevantImages) {
            if (ele.parentElement.classList.contains('product-detail__thumbnails')) {
                if (variantDataMediaIdEles.includes(ele)) {
                    ele.style.display = 'block'
                } else {
                    ele.style.display = 'none'
                }
            }
        }
    }
}

function getImageElements() {
    const relevantDesktopImages = [];
    const desktopThumbs = document.getElementsByClassName('product-detail__thumbnail');
    for (const desktopThumb of desktopThumbs) {
        relevantDesktopImages.push(desktopThumb)
    }
    return [relevantDesktopImages]
}

function changeVariantDescriptions(variants, variantId) {
    const divs = $("div[id^=div_tab_]");
    const variantDivs = $("div[id^=variant_div_]");

    const mergedDivs = divs.toArray().concat(variantDivs.toArray());

    variants.forEach(function (variant) {
        for (const div of mergedDivs) {
            if (div.id.includes(variant.id)) {
                if (variant.id == variantId) {
                    div.style.display = 'block'
                } else {
                    div.style.display = 'none'
                }
            }
        }
    })
}

function changeProgressBar(variantId) {
    $('.variant-progress').each(function () {
        if ($(this).attr('data-variant-id') == variantId) {
            $(this).show()
        } else {
            $(this).hide()
        }
    })
}